// extracted by mini-css-extract-plugin
export var after = "BeforeAndAfterModule-module--after--086eb";
export var beforeAndAfterContainer = "BeforeAndAfterModule-module--beforeAndAfterContainer--06704";
export var contain = "BeforeAndAfterModule-module--contain--17477";
export var content = "BeforeAndAfterModule-module--content--d87d8";
export var itemContainer = "BeforeAndAfterModule-module--itemContainer--071dc";
export var itemImage = "BeforeAndAfterModule-module--itemImage--44e3c";
export var itemImageContainer = "BeforeAndAfterModule-module--itemImageContainer--02953";
export var itemSubtitle = "BeforeAndAfterModule-module--itemSubtitle--9009e";
export var itemTitle = "BeforeAndAfterModule-module--itemTitle--58f61";
export var smallerFontSize = "BeforeAndAfterModule-module--smallerFontSize--b3194";
export var stretchItems = "BeforeAndAfterModule-module--stretchItems--da218";
export var video = "BeforeAndAfterModule-module--video--0bb17";